<template>
  <div>
    <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="10000">
      <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>

    <v-overlay :value="!loader">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <Strong>Note : If any data is not available or applicable, kindly mention NA</Strong>

    <v-form id="medical_details_form" @submit.prevent="submit" v-model="isValid" v-if="loader">
      <v-row dense justify="center">
        <v-col cols="10" sm="10" md="10">
          <input type="hidden" :value="application_form_data.admission_form_id" name="admission_form_id" />
        </v-col></v-row>
      <v-row dense justify="center" v-if="family_physician_name != null">

        <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-text-field dense v-model.trim="family_physician_name.field_value" :name="family_physician_name.field_name"
            :required="true" :rules="true ? [v => !!v || family_physician_name.field_display_name + ' is required'] : []"
            :clearable="family_physician_name.required ? false : true" :prepend-icon="family_physician_name.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
              " outlined :hint=family_physician_name.field_display_name persistent-hint></v-text-field> </v-col></v-row>

      <v-row dense justify="center" v-if="family_physician_number != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-text-field dense type="number" v-model.trim="family_physician_number.field_value"
            :name="family_physician_number.field_name" :required="family_physician_number.required"
            :rules="true?[
                v => !!v || 'Mobile Number is required',
                v => (v && v.length == 10) || 'Mobile Number Must be 10 digit'
                ]:[v => ((v==null || v=='')?true:(v.length==0||v.length == 10))  || 'Mobile Number Must be 10 digit']"
                            counter
                            maxlength="10"
            :clearable="family_physician_number.required ? false : true" :prepend-icon="family_physician_number.field_value != null
              ? 'mdi-account-circle'
              : 'mdi-account-circle-outline'
              " outlined :hint=family_physician_number.field_display_name persistent-hint></v-text-field>
        </v-col></v-row>

      <v-row dense justify="center" v-if="emrg_hospital_name != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-text-field dense v-model.trim="emrg_hospital_name.field_value" :name="emrg_hospital_name.field_name"
            :required="true" :rules="true
                ? [v => !!v || emrg_hospital_name.field_display_name + ' is required']
                : []
              " :clearable="emrg_hospital_name.required ? false : true" :prepend-icon="emrg_hospital_name.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
              " outlined :hint=emrg_hospital_name.field_display_name persistent-hint></v-text-field> </v-col></v-row>

      <v-row dense justify="center" v-if="emrg_hospital_number != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-text-field dense type="number" v-model.trim="emrg_hospital_number.field_value"
            :name="emrg_hospital_number.field_name" :required="emrg_hospital_number.required"
            :rules="true ? [v => !!v || emrg_hospital_number.field_display_name + ' is required'] : []"
            :clearable="emrg_hospital_number.required ? false : true" :prepend-icon="emrg_hospital_number.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
              " outlined :hint=emrg_hospital_number.field_display_name persistent-hint></v-text-field> </v-col></v-row>

      <v-row dense justify="center" v-if="family_doctor_name != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error">*</v-icon>
          <v-text-field dense v-model.trim="family_doctor_name.field_value" :name="family_doctor_name.field_name"
            :required="true" :rules="true
                ? [v => !!v || family_doctor_name.field_display_name + ' is required']
                : []
              " :clearable="family_doctor_name.required ? false : true" :prepend-icon="family_doctor_name.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
              " outlined :hint=family_doctor_name.field_display_name persistent-hint></v-text-field> </v-col></v-row>

      <v-row dense justify="center" v-if="family_doctor_contact != null">
        <v-col cols="10" sm="10" md="10" style="margin-top: -15px;">
          <v-icon color="error">*</v-icon>
          <v-text-field dense type="number" v-model.trim="family_doctor_contact.field_value"
            :name="family_doctor_contact.field_name" :required="family_doctor_contact.required"
            :rules="true?[
                v => !!v || 'Mobile Number is required',
                v => (v && v.length == 10) || 'Mobile Number Must be 10 digit'
                ]:[v => ((v==null || v=='')?true:(v.length==0||v.length == 10))  || 'Mobile Number Must be 10 digit']"
                            counter
                            maxlength="10"
            :clearable="family_doctor_contact.required ? false : true" :prepend-icon="family_doctor_contact.field_value != null
                ? 'mdi-account-circle'
                : 'mdi-account-circle-outline'
              " outlined :hint=family_doctor_contact.field_display_name persistent-hint></v-text-field> </v-col></v-row>

      <v-row dense justify="center" v-if="emergency_contact_name">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="emergency_contact_name.required">*</v-icon>
          <v-text-field dense type="text" v-model.trim="emergency_contact_name.field_value"
            :name="emergency_contact_name.field_name" :required="emergency_contact_name.required"
            :rules="emergency_contact_name.required ? [v => !!v || 'Emergency Contact Name is required'] : []"
            :hint=emergency_contact_name.field_display_name persistent-hint single-line outlined
            :clearable="emergency_contact_name.required ? false : true"
            prepend-icon="mdi-account-circle"></v-text-field>
        </v-col>
      </v-row>
      <v-row dense justify="center" v-if="emergency_contact_number">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="emergency_contact_number.required">*</v-icon>
          <v-text-field dense type="number" v-model="emergency_contact_number.field_value"
            :name="emergency_contact_number.field_name" :required="emergency_contact_number.required"
            :rules="true?[
                v => !!v || 'Mobile Number is required',
                v => (v && v.length == 10) || 'Mobile Number Must be 10 digit'
                ]:[v => ((v==null || v=='')?true:(v.length==0||v.length == 10))  || 'Mobile Number Must be 10 digit']"
                            counter
                            maxlength="10"
            :hint=emergency_contact_number.field_display_name persistent-hint single-line outlined
            :clearable="emergency_contact_number.required ? false : true"
            prepend-icon="mdi-phone-classic"></v-text-field>
        </v-col>
      </v-row>



      <v-row dense justify="center" v-if="bloodgroup != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="bloodgroup.required">*</v-icon>
          <v-autocomplete dense v-model="bloodgroup.field_value" :items="bloodgroup.options"
            :name="bloodgroup.field_name" :required="bloodgroup.required" :rules="bloodgroup.required
                ? [v => !!v || bloodgroup.field_display_name + ' is required']
                : []
              " :clearable="bloodgroup.required ? false : true" single-line prepend-icon="mdi-blood-bag" outlined
            :hint=bloodgroup.field_display_name persistent-hint></v-autocomplete> </v-col></v-row>

      <v-row dense justify="center" v-if="medical_problem != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="medical_problem.required">*</v-icon>
          <v-textarea dense :value="medical_problem.field_value" v-model="medical_problem.field_value"
            :name="medical_problem.field_name" :required="medical_problem.required" :rules="medical_problem.required
                ? [
                  v =>
                    !!v || medical_problem.field_display_name + ' is required'
                ]
                : []
              " :clearable="medical_problem.required ? false : true" :hint=medical_problem.field_display_name
            persistent-hint :prepend-icon="medical_problem.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
              " outlined></v-textarea> </v-col></v-row>

      <v-row dense justify="center" v-if="medication != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="medication.required">*</v-icon>
          <v-textarea dense :value="medication.field_value" v-model="medication.field_value"
            :name="medication.field_name" :required="medication.required" :rules="medication.required
                ? [
                  v =>
                    !!v || medication.field_display_name + ' is required'
                ]
                : []
              " :clearable="medication.required ? false : true" :hint=medication.field_display_name persistent-hint
            :prepend-icon="medication.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
              " outlined></v-textarea> </v-col></v-row>

      <v-row dense justify="center" v-if="allergy != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="allergy.required">*</v-icon>
          <v-textarea dense :value="allergy.field_value" v-model="allergy.field_value" :name="allergy.field_name"
            :required="allergy.required" :rules="allergy.required
                ? [
                  v =>
                    !!v || allergy.field_display_name + ' is required'
                ]
                : []
              " :clearable="allergy.required ? false : true" :hint=allergy.field_display_name persistent-hint
            :prepend-icon="allergy.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
              " outlined></v-textarea> </v-col></v-row>

      <v-row dense justify="center" v-if="any_chronological_disease != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="any_chronological_disease.required">*</v-icon>
          <v-textarea dense :value="any_chronological_disease.field_value"
            v-model="any_chronological_disease.field_value" :name="any_chronological_disease.field_name"
            :required="any_chronological_disease.required" :rules="any_chronological_disease.required
                ? [
                  v =>
                    !!v || any_chronological_disease.field_display_name + ' is required'
                ]
                : []
              " :clearable="any_chronological_disease.required ? false : true"
            :hint=any_chronological_disease.field_display_name persistent-hint :prepend-icon="any_chronological_disease.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
              " outlined></v-textarea> </v-col></v-row>
      <v-row dense justify="center" v-if="physical_activity_needs_to_avoid != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="physical_activity_needs_to_avoid.required">*</v-icon>
          <v-textarea dense :value="physical_activity_needs_to_avoid.field_value"
            v-model="physical_activity_needs_to_avoid.field_value" :name="physical_activity_needs_to_avoid.field_name"
            :required="physical_activity_needs_to_avoid.required" :rules="physical_activity_needs_to_avoid.required
              ? [
                v =>
                  !!v || physical_activity_needs_to_avoid.field_display_name + ' is required'
              ]
              : []
              " :clearable="physical_activity_needs_to_avoid.required ? false : true"
            :hint=physical_activity_needs_to_avoid.field_display_name persistent-hint :prepend-icon="physical_activity_needs_to_avoid.field_value != null
              ? 'mdi-hospital-box'
              : 'mdi-hospital-box-outline'
              " outlined></v-textarea> </v-col></v-row>
      <v-row dense justify="center" v-if="identification_mark_on_body != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="identification_mark_on_body.required">*</v-icon>
          <v-textarea dense :value="identification_mark_on_body.field_value"
            v-model="identification_mark_on_body.field_value" :name="identification_mark_on_body.field_name"
            :required="identification_mark_on_body.required" :rules="identification_mark_on_body.required
                ? [
                  v =>
                    !!v || identification_mark_on_body.field_display_name + ' is required'
                ]
                : []
              " :clearable="identification_mark_on_body.required ? false : true"
            :hint=identification_mark_on_body.field_display_name persistent-hint :prepend-icon="identification_mark_on_body.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
              " outlined></v-textarea> </v-col></v-row>


      <v-row dense justify="center" v-if="height_in_cm != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="height_in_cm.required">*</v-icon>
          <v-text-field dense v-model.trim="height_in_cm.field_value" :name="height_in_cm.field_name" type="number"
            :required="height_in_cm.required" :clearable="height_in_cm.required ? false : true" :prepend-icon="height_in_cm.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
              " outlined :hint=height_in_cm.field_display_name persistent-hint></v-text-field>
          <!-- :rules="
                  height_in_cm.required
                    ? [
                        v =>
                          !!v ||
                          height_in_cm.field_display_name + ' is required'
                      ]
                    : []
                " -->
        </v-col></v-row>

      <v-row dense justify="center" v-if="weight_in_kg != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="weight_in_kg.required">*</v-icon>
          <v-text-field dense v-model.trim="weight_in_kg.field_value" :name="weight_in_kg.field_name" type="number"
            :required="weight_in_kg.required" :clearable="weight_in_kg.required ? false : true" :prepend-icon="weight_in_kg.field_value != null
                ? 'mdi-alpha-a-circle'
                : 'mdi-alpha-a-circle-outline'
              " outlined :hint=weight_in_kg.field_display_name persistent-hint></v-text-field>
          <!-- :rules="
                  weight_in_kg.required
                    ? [
                        v =>
                          !!v ||
                          weight_in_kg.field_display_name + ' is required'
                      ]
                    : []
                " -->
        </v-col></v-row>
      <v-row dense justify="center" v-if="vacination != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="vacination.required">*</v-icon>
          <v-autocomplete dense v-model="vacination.field_value" :items="vacination.options"
            :name="vacination.field_name" :required="vacination.required" :rules="vacination.required
                ? [
                  v =>
                    !!v ||
                    vacination.field_display_name +
                    ' is required'
                ]
                : []
              " :clearable="vacination.required ? false : true" :hint=vacination.field_display_name persistent-hint
            single-line prepend-icon="mdi-account" outlined></v-autocomplete> </v-col></v-row>

      <!-- <v-row justify="center"> 
        <v-btn small color="warning" dark @click="openDialog = true">
            Add Medical Details
      </v-btn>
      </v-row> -->

      <!-- {{medical_declaration}}

      --
      {{isValid}} -->

      <v-row dense justify="center" v-if="medical_declaration_value != ''">
        <span v-html="medical_declaration_value"></span>
      </v-row>

      <v-row dense justify="center" v-if="foods_to_be_avoided != null">
        <v-col cols="10" sm="10" md="10">
          <v-icon color="error" v-if="foods_to_be_avoided.required">*</v-icon>
          <v-textarea dense :value="foods_to_be_avoided.field_value" v-model="foods_to_be_avoided.field_value"
            :name="foods_to_be_avoided.field_name" :required="foods_to_be_avoided.required" :rules="foods_to_be_avoided.required
                ? [
                  v =>
                    !!v || foods_to_be_avoided.field_display_name + ' is required'
                ]
                : []
              " :clearable="foods_to_be_avoided.required ? false : true" :hint=foods_to_be_avoided.field_display_name
            persistent-hint :prepend-icon="foods_to_be_avoided.field_value != null
                ? 'mdi-hospital-box'
                : 'mdi-hospital-box-outline'
              " outlined></v-textarea> </v-col></v-row>
      <v-row dense justify="center">
        <v-col cols="10" sm="10" md="10">
          <v-checkbox v-model="medical_declaration" name="medical_declaration" color="primary darken-1"
            label="I hereby verify that I have read, understood and accepted the statements above"
            :rules="[v => !!v || 'You must agree to continue!']" required></v-checkbox>
        </v-col>
      </v-row>


      <v-row justify="center" dense>
        <v-col cols="10" sm="10" md="10">
          <div style="text-align:center">
            <v-btn class="mt-2" :color="isValid ? 'primary darken-1' : 'grey lighten-1'" @click="submit"
              :disabled="!isValid">Save</v-btn>
          </div>
        </v-col></v-row>
    </v-form>
    <v-dialog v-model="openDialog" max-width="900px">
      <v-card>
        <v-toolbar class="toolbar" flat dense>
          <v-toolbar-title>
            <strong> Add Stundet Medical History</strong>
          </v-toolbar-title>
        </v-toolbar>
        <v-col cols="12" sm="12" md="12">
          <v-card class="box">
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <v-text-field outlined dense type="date" v-model="fromdate" label="From Date"
                  hint="From Date"></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <v-textarea outlined name="input-7-4" v-model="health_problem"
                  label="Enter Nature Of Health Problem "></v-textarea>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-col cols="12" sm="3">
                <v-text-field outlined v-model.trim="remark" label="Enter Remark "></v-text-field>
              </v-col>
            </v-row>
            <v-row justify="center" dense>
              <v-btn class="button" @click="saveMedicalHistory()">save</v-btn>
              <v-btn class="button" @click="openDialog = false">Close</v-btn>
            </v-row>
          </v-card>
        </v-col>
      </v-card>
    </v-dialog>




  </div>
</template>
<script>
import axios from "axios";
export default {
  data() {
    return {
      checkbox: false,
      remark: "",
      health_problem: "",
      fromdate: new Date().toISOString().slice(0, 10),
      openDialog: false,
      isValid: true,
      loader: false,
      snackbar_msg: "",
      color: "",
      snackbar: false,
      application_form_data: {
        admission_form_no: "",
        admission_form_id: "",
        display_admission_form_no: ""
      },
      family_physician_name: {},
      family_physician_number: {},
      emrg_hospital_name: {},
      emrg_hospital_number: {},
      family_doctor_name: {},
      family_doctor_contact: {},
      height_in_cm: {},
      weight_in_kg: {},
      medical_problem: {},
      bloodgroup: {},
      allergy: {},
      medication: {},
      height_in_cm: {},
      weight_in_kg: {},
      vacination: {},
      medical_declaration: true,
      any_chronological_disease: {},
      physical_activity_needs_to_avoid: {},
      emergency_contact_name: {}, emergency_contact_number: {}, identification_mark_on_body: {}, medical_declaration_value: null, foods_to_be_avoided: {},

    };
  },
  methods: {
    saveMedicalHistory() {
      const data = {
        admission_form_id: this.application_form_data.admission_form_id,
        fromdate: this.fromdate,
        health_problem: this.health_problem,
        remark: this.remark
      };
      axios
        .post("/admissionForm/saveMedicalHistory", data)
        .then((res) => {
          if (res.data.form_saved == "YES") {
            this.openDialog = false
            this.health_problem = ""
            this.remark = ""
            this.showSnackbar("green", "Added Successfully..!"); // show snackbar on success
          } else {
            this.showSnackbar("#b71c1c", "Unable to delete...!"); // show snackbar on success
          }
        })
        .catch((error) => {
          this.showSnackbar("#b71c1c", "Error...!"); // show snackbar on success
        });
    },
    checkdeclarations() {
      // alert(this.medical_declaration)
      // alert(this.isValid)
      //  this.isValid=true
      if (this.medical_declaration == true && !this.isValid) {
        // alert("else")
        this.isValid = false
      }
      else if (!this.medical_declaration || this.medical_declaration == null || this.medical_declaration == '') {
        //  alert("iff")
        this.isValid = false
      }
      else if (this.medical_declaration == true && this.isValid) {
        // alert("else")
        this.isValid = true
      }
      else {
        this.isValid = true
      }
    },
    submit: function (e) {
      if (!this.medical_declaration || this.medical_declaration == null || this.medical_declaration == '') {
        this.showSnackbar("red", "Please Accept Terms And Conditions..."); // show snackbar on success
        return
      }
      this.loader = false;
      var form = document.getElementById("medical_details_form");
      var formData = new FormData(form);
      axios.post("/admissionForm/savemedicalDetails", formData)
        .then(
          response => {
            // success callback
            // this.form_progress = response.data.form_progress
            if (response.data.form_saved == "YES") {
              this.loader = true;
              this.showSnackbar(
                "#4caf50",
                'Saved Successfully...Click on Next Tab To Continue'
              ); // show snackbar on success
            }
            else {
              this.loader = true;
              this.showSnackbar(
                "red",
                response.data.snackbar
              ); // show snackbar on success
              return
            }
            this.$store.commit("setform_progress", response.data.form_progress);
          },
          response => {
            // error callback
          }
        )
        .catch((error) => {
          console.log(error)
          this.loader = true;
          this.showSnackbar(
            "red",
            'something went wrong!!!'
          ); // show snackbar on success
        });
    },
    getform() {
      axios
        .post("/admissionForm/medicalDetails", this.application_form_data)
        .then(res => {
          if (res.data.msg == "200") {
            this.loader = true;
            this.family_physician_name = res.data.family_physician_name;
            this.family_physician_number = res.data.family_physician_number;
            this.emrg_hospital_name = res.data.emrg_hospital_name;
            this.emrg_hospital_number = res.data.emrg_hospital_number;
            this.family_doctor_name = res.data.family_doctor_name;
            this.family_doctor_contact = res.data.family_doctor_contact;
            this.height_in_cm = res.data.height_in_cm;
            this.weight_in_kg = res.data.weight_in_kg;
            this.medication = res.data.medication;
            this.bloodgroup = res.data.bloodgroup;
            this.medical_problem = res.data.medical_problem;
            this.allergy = res.data.allergy;
            this.vacination = res.data.vacination;
            this.any_chronological_disease = res.data.any_chronological_disease;
            this.physical_activity_needs_to_avoid = res.data.physical_activity_needs_to_avoid;
            this.emergency_contact_name = res.data.emergency_contact_name;
            this.emergency_contact_number = res.data.emergency_contact_number;
            this.identification_mark_on_body = res.data.identification_mark_on_body;
            this.medical_declaration_value = res.data.medical_declaration_value;
            this.foods_to_be_avoided = res.data.foods_to_be_avoided;
            this.$store.commit("setform_progress", res.data.form_progress);
            //this.form_progress = res.data.form_progress
          }
        })
        .catch(error => {
          window.console.log(error);
        });
    },

    showSnackbar(clr, msg) {
      this.snackbar = true;
      this.color = clr;
      this.snackbar_msg = msg;
    }
  },
  mounted() {
    this.application_form_data = this.$store.getters.application_form_data;
    this.getform();
  },
  watch: {
    date(val) {
      this.date_of_birth.field_value = this.formatDate(this.date);
    }
  },

};
</script>
